import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ICADLARequesterRegister = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    zipCode: '',
    serviceNeeds: '',
    referralSource: 'ICADLA'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleZipCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 5);
    setFormData(prevState => ({
      ...prevState,
      zipCode: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    
    try {
      console.log('Sending ICADLA requester registration:', formData);
      
      const API_BASE = window.location.hostname === 'localhost' 
        ? 'http://localhost:5000' 
        : '';
      
      const response = await fetch(`${API_BASE}/api/icadla/requester`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      
      console.log('ICADLA Requester registration response:', result);
      
      if (result.success) {
        setSubmitMessage(result.message || 'Thank you for registering! You\'ll receive 20% off bookkeeping services. We\'ll match you with qualified bookkeepers in your area soon.');
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          zipCode: '',
          serviceNeeds: '',
          referralSource: 'ICADLA'
        });
      } else {
        setSubmitMessage(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error('ICADLA Requester registration error:', error);
      setSubmitMessage('Sorry, there was an error with your registration. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page icadla-register">
      <div className="container">
        <div className="promo-header">
          <Link to="/icadla" className="back-link">← Back to Holiday Promotion</Link>
          <h1>🎄 Find Bookkeeping Services - 20% Off!</h1>
          <p className="promo-notice">
            Register now and get matched with professional bookkeepers at 20% off regular rates!
          </p>
        </div>
        
        <form className="registration-form icadla-form" onSubmit={handleSubmit}>
          {submitMessage && (
            <div className={`submit-message ${submitMessage.includes('Error') ? 'error' : 'success'}`}>
              {submitMessage}
            </div>
          )}
          
          <div className="form-section">
            <h3>Your Information</h3>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="fullName">Full Name *</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(123) 456-7890"
                  required
                  disabled={isSubmitting}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="zipCode">Zip Code *</label>
                <input
                  type="text"
                  id="zipCode"
                  name="zipCode"
                  value={formData.zipCode}
                  onChange={handleZipCodeChange}
                  maxLength="5"
                  pattern="[0-9]{5}"
                  title="5-digit zip code"
                  required
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="serviceNeeds">What bookkeeping services do you need?</label>
              <textarea
                id="serviceNeeds"
                name="serviceNeeds"
                value={formData.serviceNeeds}
                onChange={handleChange}
                rows="3"
                placeholder="e.g., Monthly bookkeeping, tax preparation, payroll services, QuickBooks setup..."
                disabled={isSubmitting}
              ></textarea>
            </div>
          </div>

          <div className="promo-benefits">
            <h3>🎁 Your Holiday Benefits</h3>
            <ul>
              <li>✓ 20% discount on all bookkeeping services</li>
              <li>✓ Matched with pre-vetted professionals</li>
              <li>✓ Local bookkeepers in your area</li>
              <li>✓ Quick response within 24 hours</li>
              <li>✓ No obligation - we'll find the perfect match for you</li>
            </ul>
          </div>
          
          <button 
            type="submit" 
            className="submit-btn holiday-btn requester-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Registering...' : '🎄 Get 20% Off Now!'}
          </button>

          <p className="privacy-notice">
            Your information is secure. We'll only share it with matched bookkeepers and you can opt out at any time.
          </p>
        </form>
      </div>
    </div>
  );
};

export default ICADLARequesterRegister;